import { combineReducers } from "redux";
import {
    PORTALMENU_GET_PAGE,
    PORTALMENU_GET_LIST_PAGE,
    PORTAL_ADD_MENU,
    PORTAL_EDIT_MENU,
    PORTAL_DELETE_MENU,
    PORTAL_SUBMENU_VIEW,
    PORTAL_ADD_SUBMENU_VIEW,
    PORTAL_EDIT_SUBMENU_VIEW,
    PORTAL_DELETE_SUBMENU_VIEW,
    PORTAL_VIEW_CONTENT,
    PORTAL_ADD_VIEW_CONTENT,
    PORTAL_EDIT_VIEW_CONTENT,
    PORTAL_DELETE_VIEW_CONTENT,
    PORTAL_VIEW_PRODUCT,
    GET_DATA_CARD_LOADING,
    GET_DATA_CARD_SUCCESS,
    GET_DATA_CARD_ERROR,
    PORTAL_OPTION_JENIS_BARANG,
    PORTAL_OPTION_PROVINSI,
    PORTAL_OPTION_SUPPLIER,
} from "../actions/portalAction";

const portalGetPage = (
    state = { isLoad: false, data: { data: [] }, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTALMENU_GET_PAGE:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portalGetListPage = (
    state = { isLoad: false, data: [], status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTALMENU_GET_LIST_PAGE:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portalAddMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_ADD_MENU:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portaEditMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_EDIT_MENU:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portaDeleteMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_DELETE_MENU:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
// submenu
const portalSubMenuListPage = (
    state = { isLoad: false, data: [], status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_SUBMENU_VIEW:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portalAddSubMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_ADD_SUBMENU_VIEW:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};

const portalEditSubMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_EDIT_SUBMENU_VIEW:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portalDeleteSubMenuStat = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_DELETE_SUBMENU_VIEW:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};

// content
const portalContentView = (
    state = { isLoad: false, data: "", status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_VIEW_CONTENT:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};
const portalContentAdd = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_ADD_VIEW_CONTENT:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};

const portalContentEdit = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_EDIT_VIEW_CONTENT:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};

const portalContentDelete = (
    state = { isLoad: false, data: false, status: false, message: "" },
    action
) => {
    switch (action.type) {
        case PORTAL_DELETE_VIEW_CONTENT:
            return {
                isLoad: action.isLoad,
                data: action.data,
                status: action.status,
                message: action.message,
            };
        default:
            return state;
    }
};

const portalViewProduct = (
    state = { loading: false, success: false, error: false, payload: null },
    action
) => {
    switch (action.type) {
        case PORTAL_VIEW_PRODUCT + "_LOADING":
            return {
                loading: true,
                success: false,
                error: false,
                payload: null,
            };
        case PORTAL_VIEW_PRODUCT + "_ERROR":
            return {
                loading: false,
                success: false,
                error: true,
                payload: null,
            };
        case PORTAL_VIEW_PRODUCT + "_SUCCESS":
            return {
                loading: false,
                success: true,
                error: false,
                payload: action.payload,
            };
        default:
            return state;
    }
};

const portalOptionJenisBarang = (
    state = { loading: false, success: false, error: false, payload: null },
    action
) => {
    switch (action.type) {
        case PORTAL_OPTION_JENIS_BARANG + "_LOADING":
            return {
                loading: true,
                success: false,
                error: false,
                payload: null,
            };
        case PORTAL_OPTION_JENIS_BARANG + "_ERROR":
            return {
                loading: false,
                success: false,
                error: true,
                payload: null,
            };
        case PORTAL_OPTION_JENIS_BARANG + "_SUCCESS":
            return {
                loading: false,
                success: true,
                error: false,
                payload: action.payload,
            };
        default:
            return state;
    }
};

const portalOptionProvinsi = (
    state = { loading: false, success: false, error: false, payload: null },
    action
) => {
    switch (action.type) {
        case PORTAL_OPTION_PROVINSI + "_LOADING":
            return {
                loading: true,
                success: false,
                error: false,
                payload: null,
            };
        case PORTAL_OPTION_PROVINSI + "_ERROR":
            return {
                loading: false,
                success: false,
                error: true,
                payload: null,
            };
        case PORTAL_OPTION_PROVINSI + "_SUCCESS":
            return {
                loading: false,
                success: true,
                error: false,
                payload: action.payload,
            };
        default:
            return state;
    }
};

const portalOptionSupplier = (
    state = { loading: false, success: false, error: false, payload: null },
    action
) => {
    switch (action.type) {
        case PORTAL_OPTION_SUPPLIER + "_LOADING":
            return {
                loading: true,
                success: false,
                error: false,
                payload: null,
            };
        case PORTAL_OPTION_SUPPLIER + "_ERROR":
            return {
                loading: false,
                success: false,
                error: true,
                payload: null,
            };
        case PORTAL_OPTION_SUPPLIER + "_SUCCESS":
            return {
                loading: false,
                success: true,
                error: false,
                payload: action.payload,
            };
        default:
            return state;
    }
};

// Card Landing Page
const getDataCardLoading = (state = false, action) => {
    switch (action.type) {
        case GET_DATA_CARD_LOADING:
            return action.getDataCardLoading;
        default:
            return state;
    }
};

const getDataCardSuccess = (state = false, action) => {
    switch (action.type) {
        case GET_DATA_CARD_SUCCESS:
            return action.getDataCardSuccess;
        default:
            return state;
    }
};

const getDataCardError = (state = false, action) => {
    switch (action.type) {
        case GET_DATA_CARD_ERROR:
            return action.getDataCardError;
        default:
            return state;
    }
};

const dataCard = (state = [], action) => {
    switch (action.type) {
        case GET_DATA_CARD_SUCCESS:
            return action.dataCard;
        default:
            return state;
    }
};

const portalReducer = combineReducers({
    portalGetPage,
    portalGetListPage,
    portalAddMenuStat,
    portaEditMenuStat,
    portaDeleteMenuStat,

    portalSubMenuListPage,
    portalAddSubMenuStat,
    portalEditSubMenuStat,
    portalDeleteSubMenuStat,

    portalContentView,
    portalContentAdd,
    portalContentEdit,
    portalContentDelete,

    portalViewProduct,

    portalOptionJenisBarang,
    portalOptionProvinsi,
    portalOptionSupplier,

    getDataCardLoading,
    getDataCardSuccess,
    getDataCardError,
    dataCard,
});

export default portalReducer;
